<template>
  <div class="about">
    <div class="aboutTitle">{{ props.data.titleCn }}</div>
    <div class="aboutEn">{{ props.data.titleEn }}</div>
    <div class="aboutImg">
      <img :src="props.data.imgUrl" alt="" />
    </div>
    <div class="aboutContent" v-html="props.data.contentText"></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

</script>

<style lang="scss" scoped>
.about {
  opacity: 1;
  padding: 60px 20px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  &Title {
    color: rgb(44, 44, 44);
    font-family: Source Han Sans;
    font-size: 32px;
    font-weight: 700;
    line-height: 32px;
    letter-spacing: 0px;
    text-transform: uppercase;
  }
  &En {
    color: rgb(44, 44, 44);
    font-family: Rubik;
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    letter-spacing: 0px;
    text-transform: uppercase;
    margin-top: 12px;
  }
  &Img {
    height: 175px;
    margin-top: 24px;
    margin-bottom: 16px;
    img{
      width: 100%;
    }
  }
  &Content {
    color: rgb(44, 44, 44);
    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    letter-spacing: 0px;
    text-align: justify;
    text-transform: uppercase;
  }
}
</style>
